export default __webpack_public_path__ + "static/media/partner_img_01.92df015f.svg";